{
  "nl": {
    "decision": {
      "actions": {
        "add": "Voeg toe",
        "addDocument": "Document toevoegen",
        "addUnits": "Units",
        "approve": "Aanvaarden",
        "autoCloseAfterApproval": "Automatisch sluiten na goedkeuring",
        "autoCloseAfterApprovalInfo": "Beslissing sluit wanneer een voorstel is goedgekeurd",
        "autoCloseAfterDeadline": "Automatisch sluiten na deadline",
        "cancel": "Ongedaan maken",
        "changeResponsible": "Wijzig verantwoordelijke",
        "clickToSetDeadline": "Bewerk deadline",
        "closeDecision": "Sluit beslissing",
        "confirmChoices": "Keuzes bevestigen",
        "createProposal": "Maak voorstel",
        "create_decisions": "Maak beslissing aan | Maak beslissingen aan",
        "delete": "Verwijderen",
        "deleteCount": "Je staat op het punt om de beslissing voor {count} units te verwijderen. Ben je zeker? | Je staat op het punt om de beslissing voor {count} units te verwijderen. Ben je zeker?",
        "deleteMultipleDecisions": "Verwijder...",
        "delete_cancel": "Annuleer",
        "delete_decisions": "Verwijder beslissing | Verwijder beslissingen",
        "edit": "Bewerken",
        "editBudget": "Bewerk budget",
        "editDeadline": "Bewerk deadline",
        "editDecision": "Bewerk beslissing",
        "editReminders": "Bewerk herinneringen",
        "follow_decisions": "Beslissingen volgen",
        "goToDecision": "Ga naar beslissing",
        "goToProposal": "Ga naar voorstel",
        "goToSummary": "Ga naar samenvatting",
        "hide": "Depubliceer",
        "hideInfo": "Verberg info",
        "noDescription": "Klik hier om een beschrijving toe te voegen",
        "openDecision": "Open beslissing",
        "publish": "Publiceer",
        "publishAll": "Voor iedereen",
        "publishCustomer": "Publiceer voor klant",
        "publishPartners": "Publiceer voor partners",
        "reject": "Afwijzen",
        "relaunch_decision": "Beslissing opnieuw starten",
        "request_changes": "Wijzigingen aanvragen",
        "reset": "Reset",
        "save": "Opslaan",
        "save_and_share_partners": "Opslaan en delen met partners",
        "selectAll": "Selecteer alle {total} beslissingen",
        "selectChoices": "Keuzes selecteren",
        "share_proposals": "Deel voorstellen",
        "showMoreInfo": "Toon meer info",
        "stopApproving": "Annuleer selecteren",
        "submit": "Voeg toe",
        "tickBoxesDeletion": "Vink de selectievakjes aan van de bestanden die je wil verwijderen.",
        "unSelectAll": "Maak selectie leeg",
        "unfollow_decisions": "Beslissingen ontvolgen",
        "unpublishForCustomer": "Verberg voor klant",
        "unpublishForPartners": "Verberg voor beslissingspartners",
        "update": "Update",
        "upload": "Upload",
        "upload_documents": "Upload documenten",
        "upload_proposals": "Maak voorstel aan"
      },
      "attributes": {
        "amount_gross": "Bruto offerte",
        "amount_net": "Netto offerte",
        "approved_at": "Goedkeuringsdatum voorstel",
        "approved_proposal_name": "Goedgekeurd voorstel",
        "bathrooms": "Aantal badkamers",
        "bedrooms": "Aantal slaapkamers",
        "category": "Categorie",
        "customer_group_name": "Klant",
        "decision_name": "Beslissing",
        "decisions_count": "{count} beslissing | {count} beslissingen",
        "due_date": "Deadline",
        "floor": "Verdieping",
        "negative_surcharges_allowed": "Minwerken toelaten",
        "note_employee": "Notitie",
        "price_budget": "Budget",
        "price_budget_extra": "Extra budget",
        "price_budget_info": "Je kan het budget altijd later aanpassen",
        "price_budget_info_mup": "Je kan het budget altijd later per unit aanpassen",
        "price_margin": "Marge",
        "price_surcharge": "Meerwerken",
        "published": "Gepubliceerd",
        "responsible": "Verantwoordelijke",
        "status": "Status",
        "unit": "Unit",
        "verification_type": "Goedkeuring beslissing gegeven door",
        "visibility": "Visibiliteit"
      },
      "edit_actions": {
        "edit_auto_close": "Automatisch sluiten instellingen",
        "edit_close_decision": "Beslissing sluiten/openen",
        "edit_deadline": "Deadline instellen",
        "edit_margin": "Marges instellen",
        "edit_negative_surcharges_allowed": "Minwerken toelaten",
        "edit_not_interested_allowed": "'Niet geïnteresseerd' optie toestaan",
        "edit_note_employee": "Notitie bewerken",
        "edit_price_budget": "Budget instellen",
        "edit_price_budget_extra": "Extra budget instellen",
        "edit_reminders": "Herinnering instellen",
        "edit_responsible": "Verantwoordelijke instellen"
      },
      "labels": {
        "accessRights": "Klanttoegangsrechten",
        "activity": "Activiteit",
        "addDecisionNote": "Notitie toevoegen",
        "addReminders": "Voeg herinneringen toe",
        "allUnits": "Alle",
        "allow_not_interested": "'Niet geïnteresseerd'-optie toestaan",
        "allow_not_interested_cancel_warning": "Deze beslissing staat momenteel op 'Niet geïnteresseerd'. Het uitschakelen van deze optie zal de 'Niet geïnteresseerd'-status annuleren.",
        "allow_not_interested_info": "Toont een 'Niet geïnteresseerd'-optie naast de voorstellen",
        "approved": "Aanvaard",
        "approvedAt": "Aanvaard {approved_at}",
        "approvedProposal": "Aanvaard voorstel",
        "askQuestion": "Stel hier jouw vragen in verband met de beslissing {decision}.",
        "assignCustomerToUnit": "Voeg klant toe",
        "autoClose": "Automatisch sluiten",
        "budgetOverview": "Overzicht budget",
        "budgetSubtitle": "Voer hier een budget in als dit van toepassing is op alle geselecteerde units",
        "budgetTitle": "Stel een budget op",
        "checkbox": "Checkbox",
        "clickHereToChange": "Klik hier als je deze wil wijzigen.",
        "close": "Sluit",
        "closeDecision": "Beslissing sluiten",
        "closed": "De beslissing is gesloten voor deze unit. De klant kan geen voorstel meer goedkeuren.",
        "closedLabel": "Beslissing gesloten",
        "closed_tag": "Beslissing gesloten",
        "closed_tooltip_customer": "De beslissing is gesloten. Je kunt een voorstel niet meer goedkeuren.",
        "countDocuments": "Nog geen documenten | 1 document | {count} documenten",
        "countEdit": "Bewerk de beslissing van 1 unit | Bewerk de beslissing van {count} units",
        "countUpload": "Upload documenten naar deze unit | Upload documenten naar {count} units",
        "created_on": "Beslissing aangemaakt op {date}",
        "custom_columns_title": "Je kunt maximaal 10 kolommen toevoegen",
        "customer": "Klant",
        "customer_status": "Status klant",
        "decided": "Beslist",
        "decision": "Beslissing",
        "decisionBreadcrumb": "Beslissing {decision_type}",
        "decisionNotPublishedYetFor": "Beslissing nog niet gepubliceerd voor",
        "decisionNoteExplainer": "Deze notitie is alleen zichtbaar voor het team en voor de partners die deze beslissing kunnen zien",
        "decisionType": "Onderwerp beslissing",
        "decisionUnit": "Beslissing voor unit {unit}",
        "decisions": "Beslissingen",
        "decisions_all_projects": "Beslissingen alle projecten",
        "decisions_breadcrumb": "Beslissingen {project}",
        "default": "Standaard",
        "deleteExplanation": "Alle communicatie, bestanden, voorstellen en andere gegevens worden permanent van het platform verwijderd. Klanten en partners die met deze beslissingen te maken hebben, verliezen alle toegang.",
        "descriptionSubtitle": "Hier kan je meer informatie toevoegen voor je klanten",
        "descriptionTitle": "Voeg een beschrijving toe voor jouw klant",
        "documentRequired": "Ondertekend document vereist voor goedkeuring",
        "documentUnits": "Unit folder",
        "documents": "Beslissingsdocumenten",
        "dueDate": "Deadline op {date}",
        "due_date_subtitle": "Stel een datum in waarop de beslissing moet worden genomen",
        "due_date_title": "Deadline en herinneringen",
        "editDecisionNote": "Notitie aanpassen",
        "extra_options": "Extra opties",
        "false": "Nee",
        "filter": "Filteren",
        "finalSettings": "Enkele kleine instellingen",
        "finalSettingsStep": "Finale instellingen",
        "financial": "Financieel",
        "firstThingsfirst": "Algemene informatie",
        "follow": "Volgen",
        "following": "Je volgt deze beslissing. Klik om te ontvolgen.",
        "four": "4",
        "giveNewAmount": "Geef nieuw bedrag in",
        "hideCount": "Depubliceer deze beslissing voor 1 unit | Depubliceer beslissingen voor {count} units",
        "hideVisibilitySettings": "Verberg visibiliteitsinstellingen",
        "indicate_not_interested": "Geef aan dat de klant niet geïnteresseerd is in deze beslissing",
        "info": "Toon meer info",
        "infoCustomers": "Klantgegevens",
        "information": "Informatie",
        "leaveBudgetEmptyInfo": "Laat leeg als je geen meer- en minwerken wilt gebruiken",
        "make_a_decision": "Neem een beslissing",
        "marginOnBudget": "Marge op budget (%)",
        "marginOnUpgrades": "Marge op meerwerken (%)",
        "marginOnUpgradesExplainer": "De marge op meerwerken wordt ook toegepast op het extra budget die je aan een klant geeft. Het extra budget kan worden toegevoegd bij de beslissing van de unit.",
        "marginOverview": "Overzicht marges",
        "marginSubTitle": "Bereken marges automatisch als percentages",
        "marginTitle": "Gebruik margepercentages",
        "members": "Leden",
        "modifyLater": "Je kunt deze instellingen altijd later wijzigen.",
        "name": "Naam",
        "newActivity": "Nieuwe activiteit",
        "newDocument": "Nieuw document",
        "next": "Volgende",
        "no": "Nee",
        "noApprovedProposalYet": "Nog geen voorstel aanvaard",
        "noBudget": "Geen budget",
        "noCustomer": "Nog geen klant toegewezen",
        "noCustomerAssigned": "Nog geen klant aan deze unit toegewezen",
        "noDeadline": "Geen deadline",
        "noDecisionDueDate": "Selecteer een deadline",
        "noDecisionStartDate": "Geen startdatum vastgelegd",
        "noDecisionsMade": "Nog geen beslissingen gemaakt",
        "noDecisionsToMake": "Geen beslissingen te nemen.",
        "noDecisionsYet": "Nog geen beslissingen",
        "noDocumentsShared": "Geen documenten gedeeld",
        "noDueDate": "Stel eerst een deadline in om herinneringen in te kunnen stellen.",
        "noDueDateSet": "Geen deadline",
        "noExtraBudget": "Geen extra budget",
        "noMessages": "Schrijf jouw eerste bericht voor {decision} in het onderstaande vak",
        "noUnitDocuments": "Er zijn nog geen documenten toegevoegd aan de Unit folder",
        "noUnitsClick": "Nog geen units voor dit project, klik hier om toe te voegen",
        "no_result_for_search": "Geen resultaat voor deze gefilterde zoekopdracht.",
        "no_surcharges": "Geen meerwerken",
        "no_surcharges_info": "Maak voorstellen zonder financiële meerwerken",
        "notDecided": "Nog niet beslist",
        "notDecidedYet": "De klant heeft nog geen beslissing genomen.",
        "notFollowing": "Je volgt deze beslissing niet. Klik om te volgen.",
        "notPossibleToWriteMessageDeactivatedUnit": "Deze beslissing is gelinkt aan een gedeactiveerde unit. Een nieuw bericht schrijven is niet meer mogelijk.",
        "notPublished": "Niet gepubliceerd",
        "notPublishedCustomer": "Beslissing nog niet gepubliceerd voor klanten",
        "notPublishedPartners": "Beslissing nog niet gepubliceerd voor beslissingspartners",
        "notShared": "Niet gedeeld",
        "not_interested": "Niet geïnteresseerd",
        "not_interested_customer": "Niet geïnteresseerd",
        "not_interested_customer_info": "Als je niet geïnteresseerd bent in deze beslissing, of als deze beslissing niet relevant is voor jou, klik dan hier om dit aan te geven.",
        "not_interested_modal": {
          "customer": {
            "body": "Geef alstublieft wat aanvullende feedback over waarom u niet geïnteresseerd bent in deze beslissing",
            "title": "Ik ben niet geïnteresseerd in deze beslissing"
          },
          "employee": {
            "body": "Geef wat aanvullende feedback over waarom de klant niet geïnteresseerd is in deze beslissing. Deze feedback zal ook zichtbaar zijn voor de klant.",
            "title": "Klant is niet geïnteresseerd in deze beslissing"
          },
          "feedback": "Feedback"
        },
        "one": "1",
        "open": "Open",
        "openDecisionInfo": "Deze beslissing staat open. De klant kan voorstellen goedkeuren.",
        "open_auto_close_deadline_unit": "Stel in of de beslissing automatisch wordt gesloten of niet na het passeren van de deadline",
        "open_auto_close_unit": "Stel in of de beslissing automatisch wordt gesloten of niet bij goedkeuring ",
        "open_close_unit": "de beslissing voor 1 unit | de beslissing voor {unit_count} units",
        "or": "of",
        "participants": "Leden",
        "partners": "Beslissingspartners",
        "pendingDecisions": "1 beslissing te nemen | {count} beslissingen te nemen",
        "priceBudget": "Budget",
        "priceBudgetExtra": "Extra budget",
        "proposal": "Voorstellen",
        "proposals": "Voorstellen | 1 voorstel | {count} voorstellen",
        "publish?": "Opslaan en publiceren?",
        "publishNow?": "Publiceer nu?",
        "publishTopOfPage": "Je kan deze beslissing bovenaan deze pagina publiceren",
        "publishedCount": "Publiceer de beslissing voor 1 unit | Publiceer de beslissing voor {count} units",
        "publishedCustomer": "Beslissing gepubliceerd voor de klant",
        "publishedCustomerPartners": "Beslissing gepubliceerd voor klant en beslissingspartners",
        "publishedNone": "Beslissing niet gepubliceerd",
        "publishedPartners": "Beslissing gepubliceerd voor beslissingspartners",
        "publishedSince": "Beslissing gepubliceerd sinds {date}",
        "published_info": "Toont of alle units gepubliceerd zijn voor de klant en/of beslissingspartners",
        "remainOpen": "Open blijven",
        "reminders": "Herinneringen",
        "remindersCount": "1 herinnering | {count} herinneringen",
        "reopenDecision": "Beslissing opnieuw openen",
        "requiresDocumentVerification": "Vereist ondertekend document ter goedkeuring",
        "requiresNoDocumentVerification": "Geen ondertekend document vereist voor goedkeuring",
        "returnToTickets": "Ga terug",
        "rights": {
          "access_full": "Volledige toegang",
          "access_full_info": "Kan berichten, documenten en voorstellen rechtstreeks met de klant delen",
          "access_full_short": "Volledig",
          "access_none": "Gelimiteerde toegang",
          "access_none_info": "Geen communicatie met de klant: enkel intern gebruik",
          "access_none_short": "Beperkt",
          "access_semi": "Basistoegang",
          "access_semi_info": "Kan berichten sturen naar de klant, maar geen documenten of voorstellen",
          "access_semi_short": "Basis",
          "customer_show": "Ziet de klanteninformatie",
          "default": "Beslissingspartners kunnen ten alle tijde berichten sturen, documenten uploaden en voorstellen aanmaken naar <b>{client_name}</b>. Ze krijgen ook toegang tot de unit plandocumenten. Hieronder kan je hun communicatierechten naar je klanten aanpassen.",
          "document_customer": "Kan rechtstreeks documenten delen met de klant",
          "message_customer": "Kan berichten sturen naar de klant",
          "proposal_customer": "Kan rechtstreeks voorstellen maken aan de klant"
        },
        "save?": "Opslaan?",
        "saveExplainer": "Maak deze beslissing meteen zichtbaar voor jouw klanten? Of sla gewoon op en publiceer later?",
        "select": "Selecteer",
        "selectOneUnit": "Selecteer tenminste 1 unit",
        "selectUnits": "Selecteer units",
        "select_units": "Selecteer units",
        "selected": "{selected} unit geselecteerd. | {selected} units geselecteerd.",
        "sharedWith": "Gedeeld met",
        "showDecisionsFor": "Toon beslissingen van",
        "show_all_units": "Toon alle units",
        "signOnline": "Bevestig online door naam te typen (default)",
        "signUploadDocument": "Upload ondertekend document",
        "signedDocument": "Upload ondertekend document",
        "status": "Status",
        "statusExplained": "Wat betekent elke beslissingsstatus?",
        "step2Subtitle": "Selecteer het project om alle units in één keer op te nemen.",
        "step2Title": "Welke units moeten een beslissing nemen?",
        "step2TitleWithDecisionName": "Welke units moeten een beslissing nemen voor {decision_name}?",
        "subject": "Onderwerp",
        "summary": "Samenvatting",
        "surcharge_tooltip": "Dit is het meerwerk voor deze beslissing",
        "surcharges_total": "Meerwerken: {total}",
        "surcharges_total_tooltip": "Dit is het totale aantal meerwerken voor alle eenheden die een meerwerk hebben",
        "three": "3",
        "tickets": "Gesprekken",
        "toBeDecided": "Nog te beslissen",
        "toDecide": "Beslissen",
        "total": "Totaal",
        "totalSelected": "Alle {total} units zijn geselecteerd.",
        "true": "Ja",
        "two": "2",
        "type": "Type",
        "unitDecisionsWillBeShownHere": "Unit beslissingen zullen hier getoond worden",
        "unitNotActivated": "Alleen voor geactiveerde units",
        "unitSelected": "Geen units geselecteerd | 1 unit geselecteerd | {count} units geselecteerd",
        "unit_name": "Unit",
        "units": "Units",
        "unpublish": "Niet gepubliceerd",
        "unpublished": "Niet gepubliceerd",
        "uploadDocument": "Upload documenten",
        "useMargins": "Activeer margepercentages",
        "use_surcharges": "Gebruik meerwerken",
        "use_surcharges_info": "Stel een budget in voor meerwerken",
        "validation_errors": "Er zijn problemen met dit voorstel. Los ze eerst op en probeer het dan opnieuw.",
        "waitingForClient": "Wachten op klant",
        "whatTheCustomerHasBought": "Wat de klant heeft gekocht",
        "when": "Wanneer",
        "who": "Wie",
        "withAll": "Alle",
        "withClient": "Enkel met {client}",
        "withCustomer": "Met klant",
        "withCustomerName": "Met {customer}",
        "withPartners": "Enkel met beslissingspartners",
        "yes": "Ja"
      },
      "legend": {
        "all": "Alle beslissingen",
        "approved": "Beslist",
        "approvedAfterDue": "Beslissing gemaakt, na deadline",
        "created": "Nog geen voorstel",
        "decisionApproved": "Beslissing gemaakt",
        "hasDecision": "Nog geen voorstel geüpload",
        "hasProposal": "Voorstel geüpload",
        "has_proposal": "Nog te beslissen",
        "isExpired": "Deadline verlopen, geen voorstel geüpload",
        "isExpiredHasProposal": "Deadline verlopen, voorstel geüpload",
        "noDecision": "Unit behoort niet tot deze beslissing",
        "not_interested": "Niet geïnteresseerd",
        "other_decisions": "Andere beslissingen",
        "requested_changes": "Wijzigingen gevraagd",
        "waiting_for_proposal": "Wachten op voorstel"
      },
      "navigation": {
        "backToDecisions": "Terug naar beslissingen"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Hier zal je binnenkort beslissingen kunnen maken.",
            "title": "Bereid je voor!"
          },
          "no_documents": {
            "subtitle": "Hier zal je alle documenten vinden gerelateerd aan deze belissing",
            "title": "Upload documenten gerelateerd aan beslissing {decision_name}"
          }
        },
        "employees": {
          "conversations": {
            "none": {
              "subtitle": "Vanaf het moment dat er een klant aan de unit is gekoppeld zal je hier gesprekken zien",
              "title": "Hier zal je alle gesprekken omtrent deze beslissing vinden"
            }
          },
          "new": {
            "subtitle": "Laat meerdere units een beslissing maken en volg eenvoudig op.",
            "title": "Creëer jouw eerste Beslissing"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Je ontvangt een e-mail als er een nieuwe beslissing wordt gepubliceerd.",
            "title": "Je hebt nog geen beslissingen"
          }
        }
      },
      "toasts": {
        "bulk_create": "Beslissing succesvol aangemaakt | Beslissingen succesvol aangemaakt",
        "bulk_delete": "Beslissing succesvol verwijderd | Beslissingen succesvol verwijderd",
        "bulk_update": "Beslissing succesvol bijgewerkt | Beslissingen succesvol bijgewerkt",
        "follow_failed": "We konden je meldingen niet bijwerken. Probeer het opnieuw.",
        "following": "Je volgt {n} beslissing | Je volgt {n} beslissingen",
        "following_detail": "Je krijgt meldingen wanneer deze beslissingen veranderen.",
        "unfollowed": "{n} beslissing ontvolgd | {n} beslissingen ontvolgd",
        "unfollowed_detail": "Je krijgt geen meldingen meer voor deze beslissingen.",
        "update": "Beslissing succesvol bijgewerkt"
      },
      "validation": {
        "amountRequired": "Bedrag is vereist",
        "cannotUpdatePrice": "Budget kan niet worden aangepast omdat betalingsschijven op basis van deze beslissing zichtbaar zijn gemaakt voor de klant",
        "customer": {
          "need_not_interested_note": "Geef alstublieft feedback over waarom u niet geïnteresseerd bent in deze beslissing"
        },
        "employee": {
          "need_not_interested_note": "Geef feedback over waarom de klant niet geïnteresseerd is in deze beslissing."
        },
        "installmentsSent": "Sommige geselecteerde beslissingen hebben betalingsschijven die zichtbaar zijn voor de klant. Voor deze beslissingen blijft het budget ongewijzigd..",
        "mustBeZeroOrMore": "Moet 0 of meer zijn",
        "needAttachment": "Upload ten minste één nieuw document of selecteer er een uit de unit folder",
        "needNumber": "Moet een nummer zijn (bv. 8400.5)",
        "needTitle": "Titel is verplicht",
        "need_responsible": "Er is een verantwoordelijke nodig",
        "priceBudgetNotNegative": "Budget kan geen negatief getal zijn.",
        "responsibleRequired": "Verantwoordelijk vereist",
        "selectContactPerson": "Selecteer ten minste 1 contactpersoon"
      }
    }
  }
}
